import React, { useState } from 'react';
import ReactCrop from 'react-image-crop';

import { OrderImage } from 'lib/orders/images';
import { Layout, LayoutImageConfig } from 'lib/types/layout';
import { Modal } from 'lib/components/Modal';
import { LayoutModel } from 'lib/model/objects/layoutModel';

type ImageEditorModalProps = {
  onUpdateOrderImage: (orderImage: OrderImage) => void;
  orderImage: OrderImage;
  imageConfig: LayoutImageConfig;
  onClose: () => void;
  layout: Layout;
  disabled?: boolean;
  uploadFolder: string;
};

export default function ImageEditorModal({
  onUpdateOrderImage,
  orderImage,
  imageConfig,
  onClose,
  layout,
  disabled
}: ImageEditorModalProps) {
  const layoutModel = new LayoutModel(layout);

  const [crop, setCrop] = useState<Required<ReactCrop.PercentCrop>>({
    aspect: layoutModel.imageAspectRatioDecimal(imageConfig) || 0,

    // default to 100% width
    width: orderImage.crop?.widthPct || 100,

    // don't default on height so the aspect ratio starts working
    height: orderImage.crop?.heightPct || 0,
    unit: '%',
    x: orderImage.crop?.xPct || 0,
    y: orderImage.crop?.yPct || 0
  });

  return (
    <Modal
      title={'Crop Image'}
      id="crop-modal"
      onClose={onClose}
      primaryAction={{
        buttonText: 'Save Edits',
        onClick: () => {
          onUpdateOrderImage({
            ...orderImage,
            crop: {
              heightPct: crop.height,
              widthPct: crop.width,
              xPct: crop.x,
              yPct: crop.y
            }
          });
          onClose();
        },
        type: 'button'
      }}
    >
      <div className="flex justify-center">
        <ReactCrop
          ruleOfThirds
          onChange={(_crop, pctCrop) => {
            setCrop(pctCrop as Required<ReactCrop.PercentCrop>);
          }}
          locked
          crop={crop}
          src={orderImage.imageUrl}
          disabled={disabled}
        />
      </div>
    </Modal>
  );
}
